import { render } from "./ProgramsFilterPanel.vue?vue&type=template&id=bf83432c&scoped=true"
import script from "./ProgramsFilterPanel.vue?vue&type=script&lang=js"
export * from "./ProgramsFilterPanel.vue?vue&type=script&lang=js"

import "./ProgramsFilterPanel.vue?vue&type=style&index=0&id=bf83432c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bf83432c"]])

export default __exports__